import Link from "next/link";
import style from "./secondaryHeader.module.scss";

//URLs for the secondary header, set to constants for comparison to set active menu styles when we are on that page
export const ALL_PRODUCTS_URL = "/ec/dental-supplies";
export const TOP_SELLERS_URL = "/top-sellers";
export const NEW_ARRIVALS_URL = "/new-arrivals";
export const WEEKLY_SPECIALS_URL = "/weekly-specials";
export const PROMOTIONS_URL = "/mfr-promotions";

export default function SecondaryHeader({ pathname }: SecondaryHeaderProps) {
  const isActiveTab = (url: string) => {
    return pathname === url;
  };

  return (
    <div id="secondary-header" className={style.secondaryHeader}>
      <Link
        className={`${style.secondaryHeaderLink} ${isActiveTab(ALL_PRODUCTS_URL) ? style.activeMenu : ""}`}
        href={ALL_PRODUCTS_URL}
        prefetch={false}
      >
        All Products
      </Link>
      <Link
        className={`${style.secondaryHeaderLink} ${isActiveTab(TOP_SELLERS_URL) ? style.activeMenu : ""}`}
        href={TOP_SELLERS_URL}
      >
        Top Sellers
      </Link>
      <Link
        className={`${style.secondaryHeaderLink} ${isActiveTab(NEW_ARRIVALS_URL) ? style.activeMenu : ""}`}
        href={NEW_ARRIVALS_URL}
      >
        New Arrivals
      </Link>
      <Link
        className={`${style.secondaryHeaderLink} ${isActiveTab(WEEKLY_SPECIALS_URL) ? style.activeMenu : ""}`}
        href={WEEKLY_SPECIALS_URL}
      >
        Weekly Specials
      </Link>
      <Link
        className={`${style.secondaryHeaderLink} ${isActiveTab(PROMOTIONS_URL) ? style.activeMenu : ""}`}
        href={PROMOTIONS_URL}
      >
        Promotions
      </Link>
    </div>
  );
}

export type SecondaryHeaderProps = {
  pathname: string;
};
